import Dashboard from "./menu/Dashboard/Dashboard.vue";
import Reports from "./menu/Reports/Reports.vue";


import Users from "./menu/Users/index.vue";
import usersRoutes from "./menu/Users/router.js";

import Products from "./menu/Products/index.vue";
import productsRoutes from "./menu/Products/router.js";

import Finance from "./menu/Finance/index.vue";
import financeRoutes from "./menu/Finance/router.js";

import Marketing from "./menu/Marketing/index.vue";
import marketingRoutes from "./menu/Marketing/router.js";

import Orders from "./menu/Orders/index.vue";
import ordersRoutes from "./menu/Orders/router.js";

import Settings from "./menu/Settings/index.vue";
import settingsRoutes from "./menu/Settings/router.js";

import Paxelcorp from "./menu/Paxelcorp/index.vue";
import paxelcorpRoutes from "./menu/Paxelcorp/router.js";

import Sla from "./menu/Sla/index";
import slaRoutes from "./menu/Sla/router";

import pageNotFound from "./404.vue";

const appRoutes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
  },
  {
    path: "/reports",
    name: "reports",
    component: Reports,
  },
  {
    path: "/users",
    name: "users",
    children: usersRoutes,
    component: Users,
  },
  {
    path: "/products",
    name: "products",
    children: productsRoutes,
    component: Products,
  },
  {
    path: "/finance",
    name: "Finance",
    children: financeRoutes,
    component: Finance,
  },
  {
    path: "/marketing",
    name: "Marketing",
    children: marketingRoutes,
    component: Marketing,
  },
  {
    path: "/order",
    name: "Order",
    children: ordersRoutes,
    component: Orders,
  },
  {
    path: "/Settings",
    name: "Settings",
    children: settingsRoutes,
    component: Settings,
  },
  {
    path: "/paxel-corp",
    name: "Paxel-corp",
    children: paxelcorpRoutes,
    component: Paxelcorp,
  },
  {
    path: "/sla",
    name: "sla",
    children: slaRoutes,
    component: Sla,
  },
  {
    path: "/:pathMatch(.*)*",
    name: "404",
    component: pageNotFound,
  },
];

export default appRoutes;
